import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';

import theme from 'shared/theme';

interface IThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider = ({ children }: IThemeProviderProps) => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
